module.exports = __webpack_public_path__ + "static/media/icon-outgoing.b8a18358.svg";